import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomTranslationsService } from '../../../operational-data-common/translations';

@Pipe({
  name: 'dashboardTileName',
  standalone: true,
})
export class DashboardTileNamePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translate: TranslateService
  ) {}

  transform(tileName: string): string {
    if (this.customTranslationsService.DASHBOARD_TILE_TYPE_TRANSLATIONS[tileName]) {
      return this.translate.instant(
        this.customTranslationsService.DASHBOARD_TILE_TYPE_TRANSLATIONS[tileName]
      );
    }

    return '';
  }
}
